import { Form } from "components/organisms";
import { FormikHelpers } from "formik";
import middleware from "middleware";
import { useStoreState } from "providers/StoreStateContext";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useCreateUserSpecification,
  useGetUserSpecifications,
  useUpdateUserSpecification,
} from "services/configuration/notifications";
import {
  INotificationSettingsForm,
  IUserSpecifications,
} from "services/configuration/notifications/types";

const Notifications = () => {
  const [isUpdate, setIsUpdate] = useState<boolean>(false);
  const getUserSpecifications = useGetUserSpecifications();
  const createUserSpecification = useCreateUserSpecification();
  const updateUserSpecification = useUpdateUserSpecification();

  const { tokenData } = useStoreState();
  const navigate = useNavigate();

  const onCreateUserSpecification = async (
    values: INotificationSettingsForm,
    helpers: FormikHelpers<INotificationSettingsForm>
  ) => {
    const userSpecification = middleware.settings.userSpecification.formToQuery(
      values,
      tokenData?.UserId ? tokenData?.UserId : ""
    );

    await createUserSpecification.mutateAsync(userSpecification, {
      onSuccess: () => navigate(0),
    });
  };

  const onUpdateUserSpecification = async (
    values: INotificationSettingsForm,
    helpers: FormikHelpers<INotificationSettingsForm>
  ) => {
    const userSpecifications =
      middleware.settings.userSpecification.formToQuery(
        values,
        tokenData?.UserId ?? ""
      ).userSpecifications;
    await updateUserSpecification.mutateAsync(userSpecifications, {
      onSuccess: () => getUserSpecifications.refetch(),
    });
  };

  const mergedNotifications = useMemo(() => {
    if (
      getUserSpecifications.data &&
      getUserSpecifications.data.userSpecifications
    ) {
      setIsUpdate(true);
      const test = middleware.settings.userSpecification.queryToForm(
        getUserSpecifications.data.userSpecifications
      );
      return middleware.settings.userSpecification.queryToForm(
        getUserSpecifications.data.userSpecifications
      );
    }
    return {};
  }, [getUserSpecifications.data]);

  return (
    <Form.NotificationSettings
      status={{
        isLoading: getUserSpecifications.isLoading,
        displayMode: false,
      }}
      initialValues={{ mockedNotifications: { ...mergedNotifications } }}
      i18nextPrefix="settings"
      onSubmit={
        isUpdate ? onUpdateUserSpecification : onCreateUserSpecification
      }
    />
  );
};

export default Notifications;
